import React, { FC } from "react";
import {
  CardIconWrapper,
  CardIconWrapperProps,
} from "../CardIconWrapper/CardIconWrapper";

import { Icon } from "@UI/Components/Icon/Icon";

import { CartesBancairesIcon } from "../../../Icons/CartesBancaires/CartesBancaires";

type Props = Omit<CardIconWrapperProps, "children">;

export const CartesBancairesCardIcon: FC<Props> = (props) => {
  return (
    <CardIconWrapper {...props}>
      <Icon as={CartesBancairesIcon} />
    </CardIconWrapper>
  );
};
